







import Vue from "vue";
import { Component } from "vue-property-decorator";
import { auth, db, firestore } from "@/scripts/firebase";
import HeaderComponent from "@/components/shared/Header.vue";
import { collectionName } from "./services/collection-name";
import { userPresence, addUser } from "@/utils/auth";
import { UserDocument } from "./services/datatypes";

@Component({
  components: {
    HeaderComponent,
  },
})
export default class App extends Vue {
  firebaseUserDetacher?: firebase.Unsubscribe;
  userDetacher?: firebase.Unsubscribe;
  async created() {
    this.firebaseUserDetacher = auth.onAuthStateChanged(
      async (firebaseUser) => {
        console.log("auth uid=", firebaseUser && firebaseUser.uid);
        this.$store.commit("setFirebaseUser", firebaseUser);

        if (!firebaseUser || !firebaseUser.uid) {
          return;
        }

        this.userDetacher = db
          .collection(collectionName.users)
          .doc(firebaseUser.uid)
          .onSnapshot(async (snapshot) => {
            if (!snapshot.exists) {
              return;
            }
            const user = snapshot.data() as UserDocument;
            if (!user.uid) {
              await addUser(firebaseUser.uid);
            }
            user.uid = snapshot.id;
            this.$store.commit("setUser", user);
          });
        userPresence();
      }
    );
  }
  get authorized(): boolean {
    return this.$store.state.firebaseUser !== undefined;
  }
  destroyed() {
    if (this.firebaseUserDetacher) {
      this.firebaseUserDetacher();
    }
    if (this.userDetacher) {
      this.userDetacher();
    }
  }
}
